import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { timer } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHttpService } from '../../../services/api-http.service';
import { NotificationDto } from '../../../models';

@Component({
  selector: 'cpf-voucher-details',
  templateUrl: './voucher-details.component.html',
  styleUrls: ['./voucher-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VoucherDetailsComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() voucher?: NotificationDto;
  @Output() backClicked = new EventEmitter<void>();

  copied = false;

  constructor(private apiHttpService: ApiHttpService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  async ngOnInit() {
    if (this.voucher) {
      return;
    }

    const id = this.route.snapshot.paramMap.get('id');
    if (!id) {
      return;
    }

    const notifications = await this.apiHttpService.getUserNotifications();
    this.voucher = (notifications || []).find(notification => notification.id === id);
  }

  navigateBack(): void {
    if (this.backClicked.observed) {
      this.backClicked.emit();
      return;
    }
    this.router.navigate(['calingo', 'account', 'vouchers']);
  }

  getInformationTranslationKey(): string {
    if (this.voucher?.type === 'meiko_voucher') {
      return 'header.notifications.meiko-voucher.text';
    }
    return '';
  }

  onCouponCopied(): void {
    this.copied = true;
    timer(2000).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.copied = false;
    });
  }
}
